export default "__VITE_ASSET__2A6Z6x1D__"